export const CredentialTypesPageStyles = {
    container: "container mx-auto sm:px-2 md:px-4 lg:px-6 py-6 flex flex-col relative gap-4 sm:gap-6 md:gap-10 lg:gap-12 ml-4 sm:ml-0 h-screen",
};